import gql from 'graphql-tag'

export const GET_USER_NEW_EMAIL = gql`
    query UserNewEmail {
        userNewEmail
    }
`